import React from 'react'
import CoachSearchResultsLayout from '@layouts/coaches-search'
import withSearchComp from '@components/coaches-search/CoachResults/SearchParentComp'


export const SearchPlaces = (props) => {
  return <CoachSearchResultsLayout {...props} />
}

export default withSearchComp(SearchPlaces)
